import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getRolePermissions } from './api'
import { Permission } from './types'

export const useRolePermissions = (role?: string, options: UseQueryOptions<Permission[]> = {}) =>
  useQuery({
    queryKey: ['permissions', role],
    queryFn: ({ signal }) => getRolePermissions(role!, signal),
    staleTime: 1000 * 60 * 60, // 1 hour,
    refetchOnWindowFocus: false,
    enabled: !!role,
    ...options,
  })
